<template>
  <div id="app">
    <div class="body_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <Mlogin />
         <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="main-content">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">{{ title }}</div>
                  <div class="title_more2">
                    <a href="/EN">Home</a>>{{ title }}
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container" v-html="Body"></div>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
      title: '',
      Body: '',
    }
  },
  components: {},
  mounted() {
    this.id = this.$route.query.ItemId
    this.GetList()
  },
  watch: {
    $route(to, from) {
      if (to.query.ItemId !== from.query.ItemId) {
        this.id = to.query.ItemId
        this.GetList()
      }
    },
  },
  methods: {
    GetList() {
      this.$store.dispatch('_getHeader', [parseInt(this.id)]).then((res) => {
        if (res.data.IsSuccess) {
          if (res.data.Data.length > 0) {
            this.title = res.data.Data[0].Title
            this.Body = res.data.Data[0].Body
            document.title = this.title
          }
        }
      })
    },
  },
}
</script>

<style>
table tr {
  border-bottom: none !important;
}

table td {
  border-bottom: none !important;
}
</style>
